
import { 
  submitUserFormType,
  submitApprovedUserFormType,
  submitSchoolFormType,
  submitExtensionFormType,
  submitChangePlusFormType,
  submitMessageCommentType,
  submitMessageDeletionType,
  submitChangeGradesType,
  submitExpiryDateType,
  updateTableType,
  submitEditCommentType,
  submitChangeSumToPayType,
 //deleteSchoolType
} from "./types";
  


  // // // // // // // // // // // // // // // // 
  //                GET INFO                   //
  // // // // // // // // // // // // // // // // 

  export const GET_USER_INFO_SAGA = () => ({
    type: 'GET_USER_INFO_SAGA',
    payload: true
  });

  export const GET_SCHOOLS_SAGA = () => ({
    type: 'GET_SCHOOLS_SAGA',
    payload: true
  });

  export const GET_SCHOOLS_2_SAGA = () => ({
    type: 'GET_SCHOOLS_2_SAGA',
    payload: true
  });

  export const GET_COLLEGES_SAGA = () => ({
    type: 'GET_COLLEGES_SAGA',
    payload: true
  });

  export const GET_USERS_SAGA = () => ({
    type: 'GET_USERS_SAGA',
    payload: true
  });

  export const GET_USERS_WITH_EMAIL_SAGA = () => ({
    type: 'GET_USERS_WITH_EMAIL_SAGA',
    payload: true
  });

  export const GET_MESSAGES_SAGA = () => ({
    type: 'GET_MESSAGES_SAGA',
    payload: true
  });

  export const GET_FREE_ACCESS_STATUS_SAGA = () => ({
    type: 'GET_FREE_ACCESS_STATUS_SAGA',
    payload: true
  });

  export const GET_APPROVED_USERS_SAGA = () => ({
    type: 'GET_APPROVED_USERS_SAGA',
    payload: true
  });


  
  



  // // // // // // // // // // // // // // // // 
  //                SET INFO                   //
  // // // // // // // // // // // // // // // // 
  

  export const SET_SCHOOLS = (payload: { [key: string]: any; }[]) => ({
    type: 'SET_SCHOOLS',
    payload: payload
  });

  export const SET_SCHOOLS_2 = (payload: { [key: string]: any; }[]) => ({
    type: 'SET_SCHOOLS_2',
    payload: payload
  });

  export const SET_COLLEGES = (payload: { [key: string]: any; }[]) => ({
    type: 'SET_COLLEGES',
    payload: payload
  });

  export const SET_USERS = (payload: { [key: string]: any; }[]) => ({
    type: 'SET_USERS',
    payload: payload
  });
  

  export const SET_USERS_WITH_EMAIL = (payload: { [key: string]: any; }[]) => ({
    type: 'SET_USERS_WITH_EMAIL',
    payload: payload
  });

  
  export const SET_APPROVED_USERS = (payload: { [key: string]: any; }[]) => ({
    type: 'SET_APPROVED_USERS',
    payload: payload
  });

  


  export const SET_MESSAGES = (payload: { [key: string]: any; }[]) => ({
    type: 'SET_MESSAGES',
    payload: payload
  });

  export const SET_FREE_ACCESS_SAGA = (payload: string) => ({
    type: 'SET_FREE_ACCESS_SAGA',
    payload: payload
  });

  export const SET_SHOW_ORG_NAME_TEXT_FIELD = (payload: boolean) => ({
    type: 'SET_SHOW_ORG_NAME_TEXT_FIELD',
    payload: payload
  });



  // // // // // // // // // // // // // // // // 
  //               SUBMIT INFO                 //
  // // // // // // // // // // // // // // // // 


  export const SUBMIT_USER_FORM_SAGA = (payload: submitUserFormType) => ({
    type: 'SUBMIT_USER_FORM_SAGA',
    payload: payload
  });

  export const SUBMIT_APPROVED_USER_FORM_SAGA = (payload: submitApprovedUserFormType) => ({
    type: 'SUBMIT_APPROVED_USER_FORM_SAGA',
    payload: payload
  });

  export const SUBMIT_SCHOOL_FORM_SAGA = (payload: submitSchoolFormType) => ({
    type: 'SUBMIT_SCHOOL_FORM_SAGA',
    payload: payload
  });


  export const SUBMIT_EXTENSION_FORM_SAGA = (payload: submitExtensionFormType) => ({
    type: 'SUBMIT_EXTENSION_FORM_SAGA',
    payload: payload
  });

  export const SUBMIT_CHANGE_PLUS_FORM_SAGA = (payload: submitChangePlusFormType) => ({
    type: 'SUBMIT_CHANGE_PLUS_FORM_SAGA',
    payload: payload
  });

  export const SUBMIT_CHANGE_EXPIRY_DATE_SAGA = (payload: submitExpiryDateType) => ({
    type: 'SUBMIT_CHANGE_EXPIRY_DATE_SAGA',
    payload: payload
  });

  export const SUBMIT_CHANGE_GRADES_SAGA = (payload: submitChangeGradesType) => ({
    type: 'SUBMIT_CHANGE_GRADES_SAGA',
    payload: payload
  });


  export const SUBMIT_CHANGE_SUM_TO_PAY_SAGA = (payload: submitChangeSumToPayType) => ({
    type: 'SUBMIT_CHANGE_SUM_TO_PAY_SAGA',
    payload: payload
  });

  

  

  export const SUBMIT_EDIT_COMMENT_SAGA = (payload: submitEditCommentType) => ({
    type: 'SUBMIT_EDIT_COMMENT_SAGA',
    payload: payload
  });

  export const SUBMIT_MESSAGE_COMMENT_SAGA = (payload: submitMessageCommentType) => ({
    type: 'SUBMIT_MESSAGE_COMMENT_SAGA',
    payload: payload
  });


  export const SUBMIT_MESSAGE_DELETION_SAGA = (payload: submitMessageDeletionType) => ({
    type: 'SUBMIT_MESSAGE_DELETION_SAGA',
    payload: payload
  });



  // // // // // // // // // // // // // // // // 
  //                  OTHER                    //
  // // // // // // // // // // // // // // // // 

  

  export const PROLONG_USERS_SAGA = () => ({
    type: 'PROLONG_USERS_SAGA',
    payload: ''
  });

  export const UPDATE_TABLE = (payload: updateTableType) => ({
    type: 'UPDATE_TABLE',
    payload: payload
  });

  export const SUBMITION_INIT = () => ({
    type: 'SUBMITION_INIT',
    payload: true
  });

  export const SUBMITION_COMPLETED = () => ({
    type: 'SUBMITION_COMPLETED',
    payload: true
  });

  export const SHOW_ERROR = () => ({
    type: 'SHOW_ERROR',
    payload: true
  });

  export const STOP_SHOWING_LOADER = () => ({
    type: 'STOP_SHOWING_LOADER',
    payload: true
  });

  export const DELETE_USER_SAGA = (payload: string) => ({
    type: 'DELETE_USER_SAGA',
    payload: payload
  });

  export const DELETE_SCHOOL_SAGA = (payload: string) => ({
    type: 'DELETE_SCHOOL_SAGA',
    payload: payload
  });

  export const DELETE_APPROVED_ORG_SAGA = (payload: string) => ({
    type: 'DELETE_APPROVED_ORG_SAGA',
    payload: payload
  });

  

  export const SET_FREE_ACCESS_STATUS = (payload: boolean) => ({
    type: 'SET_FREE_ACCESS_STATUS',
    payload: payload
  });

  

  export const RESET = () => ({
    type: 'RESET',
    payload: true
  });


  
  export const DO_TEST_SAGA = () => ({
    type: 'DO_TEST_SAGA',
    payload: true
  });


  



   
  
  
  